"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const alert_1 = __importDefault(require("./alert"));
const redirectToLogin_1 = __importDefault(require("./redirectToLogin"));
const domain = "/api";
class Request {
    // Show user the correct error message upon unsuccessful requests.
    // Accepts either a raw axios error (e.response.data) or a rejected errObj (e.message).
    // When alertMsg is false (alert: false was passed), 401 is also suppressed so the
    // caller can handle it silently (e.g. show NotFound instead of redirecting).
    handleError(e, alertMsg = true) {
        var _a, _b, _c, _d;
        const status = (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : e.status;
        if (status === 401) {
            if (alertMsg)
                (0, redirectToLogin_1.default)("You need to be logged in to proceed.");
            return;
        }
        if (!alertMsg)
            return;
        const data = (_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.data) !== null && _d !== void 0 ? _d : e.message;
        const message = data === null || data === void 0 ? void 0 : data.message;
        if (message) {
            (0, alert_1.default)(typeof message === "string" ? message : message[0], "error");
        }
        else {
            (0, alert_1.default)("An unexpected error occurred.", "error");
        }
    }
    post(url, params, options) {
        return new Promise((resolve, reject) => {
            const config = {};
            if (options === null || options === void 0 ? void 0 : options.contentType) {
                config.headers = { "Content-Type": options.contentType };
            }
            axios_1.default
                .post(`${domain}${url}`, params, config)
                .then((response) => {
                resolve(response.data);
            })
                .catch((e) => {
                this.handleError(e, options === null || options === void 0 ? void 0 : options.alert);
                const errObj = {
                    status: 0,
                    message: "",
                };
                errObj.status = e.response.status;
                errObj.message = e.response.data;
                reject(errObj);
            });
        });
    }
    get(url, options) {
        return new Promise((resolve, reject) => {
            axios_1.default
                .get(`${domain}${url}`)
                .then((response) => {
                resolve(response.data);
            })
                .catch((e) => {
                this.handleError(e, options === null || options === void 0 ? void 0 : options.alert);
                const errObj = {
                    status: 0,
                    message: "",
                };
                errObj.status = e.response.status;
                errObj.message = e.response.data;
                reject(errObj);
            });
        });
    }
    put(url, params, options) {
        return new Promise((resolve, reject) => {
            const config = {};
            if (options === null || options === void 0 ? void 0 : options.contentType) {
                config.headers = { "Content-Type": options.contentType };
            }
            axios_1.default
                .put(`${domain}${url}`, params, config)
                .then((response) => {
                resolve(response.data);
            })
                .catch((e) => {
                this.handleError(e, options === null || options === void 0 ? void 0 : options.alert);
                const errObj = {
                    status: 0,
                    message: "",
                };
                errObj.status = e.response.status;
                errObj.message = e.response.data;
                reject(errObj);
            });
        });
    }
    patch(url, params, options) {
        return new Promise((resolve, reject) => {
            const config = {};
            if (options === null || options === void 0 ? void 0 : options.contentType) {
                config.headers = { "Content-Type": options.contentType };
            }
            axios_1.default
                .patch(`${domain}${url}`, params, config)
                .then((response) => {
                resolve(response.data);
            })
                .catch((e) => {
                this.handleError(e, options === null || options === void 0 ? void 0 : options.alert);
                const errObj = {
                    status: 0,
                    message: "",
                };
                errObj.status = e.response.status;
                errObj.message = e.response.data;
                reject(errObj);
            });
        });
    }
    delete(url, options) {
        return new Promise((resolve, reject) => {
            const config = {};
            if (options && options.data) {
                config.data = options.data;
            }
            axios_1.default
                .delete(`${domain}${url}`, config)
                .then((response) => {
                resolve(response.data);
            })
                .catch((e) => {
                this.handleError(e, options === null || options === void 0 ? void 0 : options.alert);
                const errObj = {
                    status: 0,
                    message: "",
                };
                errObj.status = e.response.status;
                errObj.message = e.response.data;
                reject(errObj);
            });
        });
    }
}
exports.default = new Request();
